// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"0304ccb9","76":"188ca2e0","568":"14cc5689","585":"0e86c895","681":"eb789ed7","847":"3a9130b0","934":"58dee19a"}[chunkId] + ".chunk.js";
};